import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import PsContext from "../../context";
import { MOB_ICONS } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const SetMobilePassword = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [validated, setValidated] = useState(false);

  const [serverResponse, setServerResponse] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    axios
      .post(ServiceUrl.MOB.SET_LOGIN_PASSWORD, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          context.updateMobilePassword(context.user.uuid);
          context.setStorage("login_by", "staff");
        } else {
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
          setLoader(false);
        }
      });
  };

  const resetPass = () => {
    context.updateMobilePassword("");
    context.updateMobileUserId("");
    if (props.onReset) props.onReset();
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="container-sm" data-aos="zoom-in">
          <div className="login-img d-flex justify-content-center align-content-center">
            <img
              className="ms-3"
              src={MOB_ICONS.SCREEN_LOCK_256}
              style={{ width: "100%", maxWidth: "120px" }}
            />
          </div>
          <div className="login my-4">
            <h2 className="fw-bold text-center">Set a Screen Lock</h2>
            <p className="text-center">Edit Your Screen Lock Here</p>
          </div>
          <div className="px-3">
            {/* <img src={MOB_ICONS.SCREEN_LOCK_256} style={{ width: "60px" }} />
            <h1 className="mt-4">Set a Screen Lock</h1> */}

            <Form
              action=""
              method="post"
              noValidate
              validated={validated}
              onSubmit={handleFormSubmit}
            >
              <input
                type="hidden"
                name="staff_uuid"
                value={context.user.uuid}
              />

              <Row className="mt-4">
                <Col md={12}>
                  <Form.Control
                    type="password"
                    name="password"
                    size="lg"
                    className="fw-bold text-center"
                    placeholder="Type your password"
                    autoFocus={true}
                    required
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={12}>
                  <Button
                    type="submit"
                    className="btn-block text-uppercase bg-theme"
                    size="lg"
                    variant="danger"
                    disabled={loader}
                  >
                    {loader ? "Wait..." : "Next"}
                    {loader && (
                      <Spinner
                        animation="grow"
                        size="sm"
                        state="loading"
                        className="ms-3"
                      />
                    )}
                  </Button>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col
                  md={12}
                  className="d-flex justify-content-center align-content-center"
                >
                  <a onClick={(e) => resetPass()}>
                    <span className="text-black fs-6 me-1">
                      Didn't receive the OTP ?
                    </span>
                    <span className="theme-text fs-5 ">Resend</span>
                  </a>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
export default SetMobilePassword;
